import { MD3LightTheme as DefaultTheme, MD3Theme } from 'react-native-paper';
import { Colors } from './colors';

/**
 * Generate theme with optional Inter fonts
 * @param useInterFonts - If true, uses Inter font family. If false, uses system default.
 */
export const createBaseTheme = (useInterFonts = false): MD3Theme => {
  const fontFamily = useInterFonts ? 'Inter' : undefined;

  return {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      ...Colors,
    },
    roundness: 8,
    fonts: {
      ...DefaultTheme.fonts,
      default: {
        ...DefaultTheme.fonts.default,
        ...(fontFamily && { fontFamily }),
      },
      displayLarge: {
        ...DefaultTheme.fonts.displayLarge,
        ...(fontFamily && { fontFamily }),
      },
      displayMedium: {
        ...DefaultTheme.fonts.displayMedium,
        ...(fontFamily && { fontFamily }),
      },
      displaySmall: {
        ...DefaultTheme.fonts.displaySmall,
        ...(fontFamily && { fontFamily }),
      },
      headlineLarge: {
        ...DefaultTheme.fonts.headlineLarge,
        ...(fontFamily && { fontFamily }),
      },
      headlineMedium: {
        ...DefaultTheme.fonts.headlineMedium,
        ...(fontFamily && { fontFamily }),
      },
      headlineSmall: {
        ...DefaultTheme.fonts.headlineSmall,
        ...(fontFamily && { fontFamily }),
      },
      titleLarge: {
        ...DefaultTheme.fonts.titleLarge,
        ...(fontFamily && { fontFamily }),
      },
      titleMedium: {
        ...DefaultTheme.fonts.titleMedium,
        ...(fontFamily && { fontFamily }),
      },
      titleSmall: {
        ...DefaultTheme.fonts.titleSmall,
        ...(fontFamily && { fontFamily }),
      },
      bodyLarge: {
        ...DefaultTheme.fonts.bodyLarge,
        ...(fontFamily && { fontFamily }),
      },
      bodyMedium: {
        ...DefaultTheme.fonts.bodyMedium,
        ...(fontFamily && { fontFamily }),
      },
      bodySmall: {
        ...DefaultTheme.fonts.bodySmall,
        ...(fontFamily && { fontFamily }),
      },
      labelLarge: {
        ...DefaultTheme.fonts.labelLarge,
        ...(fontFamily && { fontFamily }),
      },
      labelMedium: {
        ...DefaultTheme.fonts.labelMedium,
        ...(fontFamily && { fontFamily }),
      },
      labelSmall: {
        ...DefaultTheme.fonts.labelSmall,
        ...(fontFamily && { fontFamily }),
      },
    },
  };
};

// Default export with Inter fonts enabled
export const BaseTheme: MD3Theme = createBaseTheme(false);
